// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"159":"94fa96ab","453":"1d453af0"}[chunkId] + ".chunk.js";
};